import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function CreateNewsletterDialog({
  open,
  onClose,
  onSubmit,
  isSubmitting = false,
  error = "",
}) {
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [type, setType] = React.useState("News");
  const [imageFile, setImageFile] = React.useState(null);
  const [validationError, setValidationError] = React.useState("");

  React.useEffect(() => {
    if (!open) {
      setTitle("");
      setDescription("");
      setType("News");
      setImageFile(null);
      setValidationError("");
    }
  }, [open]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!title.trim() || !description.trim()) {
      setValidationError("Fyll i titel och beskrivning.");
      return;
    }

    setValidationError("");
    await onSubmit({
      title: title.trim(),
      description: description.trim(),
      type,
      imageFile,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={isSubmitting ? () => {} : onClose}
      aria-labelledby="create-newsletter-dialog-title"
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id="create-newsletter-dialog-title">
          Skapa nyhetsbrev
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 0.5 }}>
            <TextField
              label="Titel"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              fullWidth
              autoFocus
            />
            <TextField
              label="Beskrivning"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              multiline
              minRows={4}
            />
            <TextField
              select
              label="Typ"
              value={type}
              onChange={(e) => setType(e.target.value)}
              fullWidth
            >
              <MenuItem value="Information">Information</MenuItem>
              <MenuItem value="Article">Article</MenuItem>
              <MenuItem value="News">News</MenuItem>
            </TextField>
            <Stack spacing={0.8}>
              <Button
                variant="outlined"
                component="label"
                sx={{ textTransform: "none" }}
              >
                Valj bild
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImageFile(e.target.files?.[0] || null)}
                />
              </Button>
              <Typography variant="caption" color="text.secondary">
                {imageFile ? imageFile.name : "Ingen bild vald"}
              </Typography>
            </Stack>
            {validationError ? (
              <Typography color="error" variant="body2">
                {validationError}
              </Typography>
            ) : null}
            {error ? (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            ) : null}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button onClick={onClose} disabled={isSubmitting}>
            Avbryt
          </Button>
          <Button type="submit" variant="contained" disabled={isSubmitting}>
            {isSubmitting ? "Sparar..." : "Skapa"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
